import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))
const Detail = lazy(() => import('./Detail'))

//	///////////////////////
//	MARK: EXPORTS
// V11 — la bibliothèque et ses assessments sont à la flotte ; le client n'en voit rien.
export const MaintenancePublicationRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--maintenance--fleet']}>
    <Route path='file/:publicationId/*' element={<Detail />} />
    <Route path='*' element={<Index />} />
  </SubRouter>
))
